var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "w-100 justify-content-center my-3" },
    [
      _c(
        "b-col",
        {
          staticClass: "d-flex align-items-center justify-content-center",
          attrs: { cols: "12" },
        },
        [
          _c("b-skeleton", {
            attrs: { animation: "fade", width: "80%", height: "1rem" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "d-flex align-items-center justify-content-center mt-1",
          attrs: { cols: "12" },
        },
        [
          _c("b-skeleton", {
            attrs: {
              type: "input",
              animation: "fade",
              width: "80%",
              height: "2rem",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }